import { FC } from "react";

import { Flex } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import type { TNoSuggestionsProps } from "./types";

const NoSuggestions: FC<TNoSuggestionsProps> = ({ message }) => {
  const { t } = useTranslation();

  return (
    <Flex justify="center" py="0.5rem">
      {message || t("common-select-no_suggestions")}
    </Flex>
  );
};
export default NoSuggestions;
